<template>
  <div class="acMobileSubscription">
    <mq-responsive class="acMobileSubscription_wrapper" target="mobile-tablet">
      <as-header-mobile
        :title="username"
        :avatar="user.avatar"
        show-points
      >
        <template #menu>
          <router-link
            :to="{ name: 'logout' }"
            class="asHeaderMain_item acMobileSubscription_logout"
            data-analytics
            data-analytics-element-type="menu_user"
            data-analytics-element-target="{ name: 'logout' }"
            data-analytics-element-id="-exit"
            :data-analytics-element-name="$t('accountExit')"
            :title="$t('accountExit')"
          >
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="22" viewBox="0 0 22 22"><defs><path id="2jg1a" d="M54 289.8l-4.8-4.8-4.9 4.8"/><path id="2jg1b" d="M41.3 288.6c-1.5 1.7-2.3 3.9-2.3 6.3 0 5.5 4.5 10 10 10s10-4.5 10-10c0-2.4-.8-4.6-2.3-6.3"/><path id="2jg1c" d="M49.2 285v11"/></defs><g><g transform="translate(-38 -284)"><g><use fill="#fff" fill-opacity="0" stroke="#0E2242" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="50" xlink:href="#2jg1a"/></g><g><use fill="#fff" fill-opacity="0" stroke="#0E2242" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="50" xlink:href="#2jg1b"/></g><g><use fill="#fff" fill-opacity="0" stroke="#0E2242" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="50" xlink:href="#2jg1c"/></g></g></g></svg>
          </router-link>
        </template>
      </as-header-mobile>

      <div class="acMobileSubscription_body">
        <div class="acMobileSubscription_text -black">
          {{ text }}
        </div>
      </div>
    </mq-responsive>

    <mq-responsive class="acMobileSubscription_wrapper lCommon bg-blue" target="desktop">
      <as-header-main>
        <template #menu>
          <router-link
            :to="{ name: 'logout' }"
            class="asHeaderMain_item acMobileSubscription_logout"
            data-analytics
            data-analytics-element-type="menu_user"
            data-analytics-element-target="{ name: 'logout' }"
            data-analytics-element-id="-exit"
            :data-analytics-element-name="$t('accountExit')"
            :title="$t('accountExit')"
          >
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="22" viewBox="0 0 22 22"><defs><path id="2jg1a" d="M54 289.8l-4.8-4.8-4.9 4.8"/><path id="2jg1b" d="M41.3 288.6c-1.5 1.7-2.3 3.9-2.3 6.3 0 5.5 4.5 10 10 10s10-4.5 10-10c0-2.4-.8-4.6-2.3-6.3"/><path id="2jg1c" d="M49.2 285v11"/></defs><g><g transform="translate(-38 -284)"><g><use fill="#fff" fill-opacity="0" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="50" xlink:href="#2jg1a"/></g><g><use fill="#fff" fill-opacity="0" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="50" xlink:href="#2jg1b"/></g><g><use fill="#fff" fill-opacity="0" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="50" xlink:href="#2jg1c"/></g></g></g></svg>
          </router-link>
        </template>
      </as-header-main>

      <div class="acMobileSubscription_body">
        <div class="acMobileSubscription_text">
          {{ text }}
        </div>
      </div>
    </mq-responsive>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import { MqResponsive } from 'vue3-mq'

import AsHeaderMobile from '@web/components/headers/AsHeaderMobile.vue'
import AsHeaderMain from '@web/components/headers/AsHeaderMain.vue'

import i18n from '@web/plugins/i18n'

import { useStore } from '@web/store'
import { useMeta } from '@web/common/vueMeta'

export default defineComponent({
  name: 'VHome',
  components: {
    MqResponsive,
    AsHeaderMobile,
    AsHeaderMain
  },
  setup () {
    const store = useStore()

    const isOpenMenu = ref(false)

    const user = computed(() => store.getters['user/user'])
    const username = computed(() => store.getters['user/username'])
    const menu = computed(() => store.getters['menu/general'])
    const text = computed(() => i18n.global.t('This version of the site is not available'))

    useMeta({
      title: text
    })

    return {
      isOpenMenu,
      username,
      user,
      text,
      menu
    }
  }
})
</script>

<style lang="scss">
.acMobileSubscription {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  &_wrapper {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
  }

  &_body {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  &_text {
    color: white;
    font-size: 36px;
    font-style: normal;
    font-weight: 800;
    line-height: 130%;
    text-align: center;

    &.-black {
      color: var(--ac-color-black);
    }
  }

  &_logout {
    padding: 0;
    margin-left: 16px;
  }

  .acPointsLabel {
    display: none;
  }
}
</style>
